var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512 148.623c0-43.269-35.202-78.471-78.472-78.471H78.471C35.202 70.152 0 105.354 0 148.623V393.18h50.665c6.508 27.853 31.528 48.667 61.335 48.667s54.827-20.815 61.335-48.667h165.329c6.508 27.853 31.529 48.667 61.336 48.667s54.827-20.815 61.336-48.667H512zm-79 230.225c0 18.196-14.804 33-33 33s-33-14.804-33-33 14.804-33 33-33 33 14.803 33 33zm-288 0c0 18.196-14.804 33-33 33s-33-14.804-33-33 14.804-33 33-33 33 14.803 33 33zm288.528-278.696c22.785 0 41.937 15.807 47.095 37.027H31.377c5.158-21.221 24.31-37.027 47.094-37.027zM482 167.18v88h-32.333v-88zm-62.333 59H239.833v-59h179.834zM30 167.18h179.833v59H30zm431.027 196.001c-6.983-27.184-31.695-47.333-61.027-47.333s-54.044 20.149-61.027 47.333H173.027c-6.983-27.184-31.695-47.333-61.027-47.333s-54.044 20.149-61.027 47.333H30V256.18h389.667v29H482v78.001z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.285 298.274a19.145 19.145 0 0 1-21.26-1.228c-15.914-11.988-37.3-13.223-54.486-3.145l-19.665 11.531 15.175 25.879 19.665-11.531a19.143 19.143 0 0 1 21.26 1.227c15.912 11.989 37.299 13.224 54.486 3.146l19.665-11.531-15.175-25.879z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/Hash.1fedf7a34ab02aabcc0d5704f0609db7.svg";
export { ForwardRef as ReactComponent };